export default "__VITE_ASSET__BYoydyC6__"